import { createFileRoute } from '@tanstack/react-router';

import { ProfileError } from './-components/error/ProfileError';
import { ProfileSkeleton } from './-components/pending/ProfileSkeleton';
import { Profile } from './-components/Profile';
import { useProfile } from './-logic/useProfile';
import { ProfileContext } from './-logic/useProfileContext';

export const Route = createFileRoute('/_authed/profile/')({
  component: ProfilePage,
  errorComponent: ProfileError,
  pendingComponent: ProfileSkeleton,
});

function ProfilePage() {
  return (
    <ProfileContext.Provider value={useProfile()}>
      <Profile />
    </ProfileContext.Provider>
  );
}
